export const allPageSizeParamValue = "all";

export const getVisiblePageNumbers = (
  currentPage: number,
  totalPages: number,
): number[] => {
  if (totalPages <= 0) {
    return [];
  }

  const start = Math.max(1, currentPage - 1);
  const end = Math.min(totalPages, start + 2);
  const adjustedStart = Math.max(1, end - 2);

  return Array.from(
    { length: end - adjustedStart + 1 },
    (_, index) => adjustedStart + index,
  );
};
